import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { ActiveSupplierQuoteFragmentDoc } from './ActiveSupplierQuote.generated'
import { BestBuyItemPricesFragmentDoc } from './BestBuyItemPrices.generated'
import { ProductItemProductFragmentDoc } from './ProductItemProduct.generated'
import * as Types from './purchasePlus_graphql'

export const QuotesModalTableViewPricesFragmentDoc = gql`
  fragment QuotesModalTableViewPrices on Price {
    uuid
    supplier {
      id
      supplierRelationship {
        id
      }
      name
    }
    product {
      id
      image
      productCode
      ...ProductItemProduct
    }
    pricedCatalogue {
      id
      title
    }
    pricedCataloguedProduct {
      id
      outOfStock
    }
    unitPrice
    taxPercentage
    preferredSupplier
    ...BestBuyItemPrices
    ...ActiveSupplierQuote
  }
  ${ProductItemProductFragmentDoc}
  ${BestBuyItemPricesFragmentDoc}
  ${ActiveSupplierQuoteFragmentDoc}
` as unknown as DocumentNode<Types.QuotesModalTableViewPricesFragment, unknown>
